import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'

const InfoButton = ({ label, onClick }) => (
  <OverlayTrigger overlay={<Tooltip>{label}</Tooltip>}>
    <Button aria-label={label} variant='link' className='p-1' onClick={onClick}>
      <FontAwesomeIcon icon={faInfoCircle} />
    </Button>
  </OverlayTrigger>
)
export { InfoButton }
